import { Controller } from "@hotwired/stimulus"

const PREFILL_RATE = 0.05
const FINANCED_PAYMENT_TYPES = ["financing", "installments"]

// Prefills "Entstandene Kosten durch Abwicklung" with 5% of the relevant reference field the
// moment "Kosten für Abwicklung von Bestandspolice berücksichtigen" is switched on: 5% of
// "Minderung der Finanzierung/Ratenzahlung" while factoring/Ratenzahlung is active, otherwise 5%
// of "Einmalzahlung". Only sets an initial value - the field stays fully editable afterwards.
export default class extends Controller {
  static targets = ["checkbox", "target", "oneTimePayment", "financingReductionAmount"]

  prefill() {
    if (!this.checkboxTarget.checked) return
    if (this.targetTarget.value !== "") return

    const paymentType = this.element.querySelector('input[name="policy_parameter[payment_type]"]:checked')?.value
    const sourceTarget = FINANCED_PAYMENT_TYPES.includes(paymentType)
      ? this.financingReductionAmountTarget
      : this.oneTimePaymentTarget

    const sourceValue = this.parseMoney(sourceTarget.value)
    if (!sourceValue) return

    this.targetTarget.value = this.formatMoney(sourceValue * PREFILL_RATE)
    this.targetTarget.dispatchEvent(new Event("blur", { bubbles: true }))
    this.targetTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  parseMoney(value) {
    return parseFloat(value.replace(/\./g, "").replace(",", ".")) || 0
  }

  formatMoney(value) {
    return new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
  }
}
